import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchTemplateById, fetchTemplates } from '../api/templateApi';
import AlertTemplateRenderer from './AlertTemplateRenderer';
import './AlertTemplate.css';

export default function AlertTemplatePage() {
  const { templateId } = useParams();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const scale = useMemo(() => {
    if (typeof window === 'undefined') return 0.5;
    const maxW = Math.min(window.innerWidth - 48, 720);
    return Math.min(1, maxW / 720);
  }, []);

  useEffect(() => {
    let active = true;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const data = templateId
          ? await fetchTemplateById(templateId)
          : (await fetchTemplates())[0];

        if (!active) return;

        if (!data) {
          setError('Template not found');
          setTemplate(null);
        } else {
          setTemplate(data);
        }
      } catch (err) {
        if (active) {
          setError(err.message || 'Failed to load template');
          setTemplate(null);
        }
      } finally {
        if (active) setLoading(false);
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [templateId]);

  return (
    <main className="alert-template-page">
      <header className="alert-template-page__header">
        <h1>{template?.name || 'Alert Template'}</h1>
        <p>Static JSON template — no legacy backend API. Replace templateApi.js when ready.</p>
      </header>

      {loading && <p style={{ textAlign: 'center' }}>Loading template…</p>}
      {error && <p style={{ textAlign: 'center', color: '#c00' }}>{error}</p>}

      {!loading && !error && template && (
        <>
          <div className="alert-template-page__preview">
            <AlertTemplateRenderer template={template} scale={scale} />
          </div>
          <pre className="alert-template-page__meta">
            {`id: ${template.id}\ndimensions: ${template.dimensions.width}×${template.dimensions.height}\nsource: staticTemplates.json`}
          </pre>
        </>
      )}
    </main>
  );
}
